import Vue from 'vue'
import Vuex from 'vuex'
import gql from '../../api/gql'
import { setCookie, clearCookie } from '../../util'
import router from '../../router'
import { configNavs } from '../../router/_nav'
Vue.use(Vuex)

const state = {
  loggedInUser: {},
  permissionInsufficient: false,
  loadingCount: 0,
  errors: {
    messages: [], 
    validateFeedback: {}, 
  },
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  i18nMessage: {},
  defaultGlobalStyles: null,
  nav: [],
}

// actions
const actions = {
  setupInitState ({ commit }, i18nIds) {
    return gql.query({
      query: `
        query($input: [String]!){
          GetI18nMessages(input: $input)
          GetMe{
            id
            username
            modules
          }
          GetDefaultGlobalStyle{
            style
          }
        }
      `,
      variables: {
        input: i18nIds,
      },
    }).then((data) => {
      const i18nMessages = data.GetI18nMessages
      for (const i18nId in i18nMessages) {
        commit('setI18nMessage', [i18nId, i18nMessages[i18nId]])  
      }

      if (data.GetMe.id) {
        commit('setLoggedInUser', data.GetMe)  
      }

      commit('setNav', configNavs(state.i18nMessage, state.loggedInUser))

      commit('setDefaultGlobalStyles', data.GetDefaultGlobalStyle.style)

      return true
    })
  },

  login({ state, commit, }, loginInfo) {
    return gql.query({
      query: `
        mutation($input: BoMemberLoginVo){
          LoginBoMember(input: $input){
            id
            jwt
            username
            modules
          }
        }
      `,
      variables: {
        input: loginInfo,
      },
    }).then(data => {
      const loggedInUser = data.LoginBoMember
      setCookie('_admin_jwt', loggedInUser.jwt, 30)
      commit('setLoggedInUser', loggedInUser)
      commit('setNav', configNavs(state.i18nMessage, loggedInUser))
      router.replace({
        name: 'Home',
      })
    })
  },

  logout ({ commit }) {
    clearCookie('_admin_jwt')
    commit('setLoggedInUser', {})
    router.push({
      name: 'Login',
    })
  },
}

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  addLoadingCount (state) {
      state.loadingCount += 1
  },
  minusLoadingCount (state) {
    state.loadingCount -= 1
  },
  setLoggedInUser (state, loggedInUser) {
    state.loggedInUser = loggedInUser
  },
  setI18nMessage (state, [i18nId, message]) {
    Vue.set(state.i18nMessage, i18nId, message)
  },
  setDefaultGlobalStyles (state, defaultGlobalStyles) {
    state.defaultGlobalStyles = defaultGlobalStyles
  },
  setNav(state, nav) {
    state.nav = nav
  }
}

export default {
    state,
    actions,
    mutations,
}